import {CtModelRouteData} from "@ctsolution/ct-framework";

export const ChildModuleItemRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("childmoduleitem");
